module.exports = __webpack_public_path__ + "img/android-icon.a57950f1.svg";